import { AfterViewInit, Component, EventEmitter, Injectable, Input, Output, ViewChild } from '@angular/core';
import { ProjectActivityPackDetails } from '../../models/ProjectActivityPackDetails.model';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Subject, takeUntil } from 'rxjs';
import { DocumentUploadComponent } from '../../../plant-manager/components/document-upload/document-upload.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MultipleFileUploadComponent } from '../multiple-file-upload/multiple-file-upload.component';
import { Attachments } from '../../models/attachments.model';
import { AttachmentType } from '../../enums/Attachment-type.enum';
import { DocumentApiService } from 'src/app/services/document-api.service';
import { UserUtilityService } from 'src/app/services';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { LinkEntityType } from '../../enums/LinkEntityType.enum';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DeleteDialogComponent } from 'src/app/shared/info-dialogs/delete-dialog/delete-dialog.component';
import { PlantList } from '../../../plant-manager/models/plant-manager.model';
import { ProjectsDetails } from '../../models/projectDetails.model';
import { ProjectmanagerService } from '../../services/projectmanager.service';

export interface PeriodicElement {
    id: string;
    documentTittle: string;
    documentNo: string;
    documentType: string;
    revision: number;
    version: number;
    added: string;
}
@Injectable()
export class MyCustomPaginatorIntl implements MatPaginatorIntl {
    changes = new Subject<void>();

    firstPageLabel = $localize`First page`;
    itemsPerPageLabel = $localize`Items per page:`;
    lastPageLabel = $localize`Last page`;
    nextPageLabel = 'Next page';
    previousPageLabel = 'Previous page';

    getRangeLabel(page: number, pageSize: number, length: number): string {
        if (length === 0) {
            return $localize`Page 1 of 1`;
        }
        const amountPages = Math.ceil(length / pageSize);
        return $localize`Page ${page + 1} of ${amountPages}`;
    }
}

@Component({
    selector: 'app-documents',
    templateUrl: './documents.component.html',
    styleUrls: ['./documents.component.scss'],
    providers: [{ provide: MatPaginatorIntl, useClass: MyCustomPaginatorIntl }],
    standalone: false
})
export class DocumentsComponent implements AfterViewInit {
    @Input() activityPackDetails: ProjectActivityPackDetails;
    @Input() JointData: PlantList;
    @Input() linkEntityType: LinkEntityType;
    @Input() linkEntityId: string;
    @Input() selectedProject: ProjectsDetails;
    @Input()
    set AttachmentsList(value: Attachments[]) {
        value.sort((a, b) => new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime());
        this._AttachmentsList = [...value];
        this.dataSource = new MatTableDataSource([...value]);
        this.dataSource.paginator = this.paginator;
    }
    get AttachmentsList(): Attachments[] {
        return this._AttachmentsList;
    }

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @Output() Documentrefresh: EventEmitter<string> = new EventEmitter(null);
    isSubscribe: Subject<any> = new Subject<any>();

    tooltip_position: string = 'above';
    searchText = '';
    currentInstanceName: string;
    displayedColumns: string[] = ['documentTittle', 'documentNo', 'documentType', 'revision', 'version', 'added', 'action'];
    attachmentType = AttachmentType;
    _AttachmentsList: Attachments[];
    attachmentsListCopy: Attachments[];
    dataSource: MatTableDataSource<Attachments>;
    LinkEntityType = LinkEntityType;

    constructor(
        private modalService: NgbModal,
        private documentApiService: DocumentApiService,
        private user_utility: UserUtilityService,
        private customToastService: CustomToastService,
        private ngxUiLoaderService: NgxUiLoaderService,
        public projectManagerService: ProjectmanagerService
    ) {
        this.currentInstanceName = localStorage.getItem('currentInstanceName');
    }

    ngAfterViewInit() {
        this.attachmentsListCopy = [...this._AttachmentsList];
    }

    addAttachment() {
        const dialogRef = this.modalService.open(DocumentUploadComponent, {
            size: 'lg',
            backdrop: 'static',
            keyboard: false,
        });
        dialogRef.componentInstance.headingName = '';
        dialogRef.componentInstance.modalMode = 'Add';
        dialogRef.componentInstance.LinkEntityId = this.linkEntityId;
        dialogRef.componentInstance.linkEntityType = this.linkEntityType;

        dialogRef.result
            .then((resp) => {
                if (resp) {
                    this.AddAttachmentAPICall(resp);
                }
            })
            .catch((e) => {
                console.warn(e);
            });
    }
    errors = [];
    addMultipleAttachment() {
        const dialogRef = this.modalService.open(MultipleFileUploadComponent, {
            size: 'lg',
            backdrop: 'static',
            keyboard: false,
        });
        dialogRef.componentInstance.headingName = '';
        dialogRef.componentInstance.modalMode = 'Add';
        dialogRef.componentInstance.linkEntityId = this.linkEntityId;
        dialogRef.componentInstance.linkEntityType = this.linkEntityType;
        dialogRef.result
            .then((attachmentList) => {
                if (attachmentList) {
                    this.errors = [];
                    attachmentList.map(async (a, index) => {
                        let formdata = new FormData();
                        formdata.append(`attachment[Name]`, a.Name);
                        formdata.append(`attachment[LinkEntityType]`, this.linkEntityType);
                        formdata.append(`attachment[LinkEntityId]`, this.linkEntityId);
                        formdata.append(`file`, a.file);
                        let isLast = index === attachmentList.length - 1 ? true : false;
                        await this.AddAttachmentAPICall(formdata, isLast);
                    });
                }
            })
            .catch((e) => {
                console.warn(e);
            });
    }

    async AddAttachmentAPICall(formData, isLast?: boolean) {
        try {
            this.ngxUiLoaderService.start();
            let attachments = await this.documentApiService.postAttachment(formData).toPromise();

            if (attachments.success) {
                this.customToastService.successToast('Attachments added Successfully!', 'Success');
                this.Documentrefresh.next(this.linkEntityType);
            } else {
                // this.user_utility.errorModelPopup(attachments.message);
                this.errors.push(attachments.message);
            }
            if (isLast && this.errors.length > 0) {
                this.user_utility.errorModelPopup('One or more of the selected files are failed to upload.  Please check the files and try again');
                isLast = false;
            }
            this.ngxUiLoaderService.stop();
        } catch (err) {
            this.errors.push(err.message);
            if (isLast && this.errors.length > 0) {
                this.user_utility.errorModelPopup('One or more of the selected files are failed to upload.  Please check the files and try again');
                isLast = false;
            }
            this.ngxUiLoaderService.stop();
        }
    }

    applyFilter(filterData: string) {
        const filterValue = filterData;
        this.dataSource.filter = filterValue?.trim()?.toLowerCase();
    }

    async editAttachment(attachment: Attachments) {
        this.ngxUiLoaderService.start();

        let result = await this.documentApiService.getAttachmentById(attachment.documentId).toPromise();

        if (result.success) {
            const dialogRef = this.modalService.open(DocumentUploadComponent, {
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
            });
            dialogRef.componentInstance.filename = result.response.filename;
            dialogRef.componentInstance.content = result.response.content;
            dialogRef.componentInstance.headingName = '';
            dialogRef.componentInstance.modalMode = 'Edit';
            dialogRef.componentInstance.LinkEntityId = this.linkEntityId;
            dialogRef.componentInstance.linkEntityType = this.linkEntityType;
            dialogRef.componentInstance.attachment = attachment;

            dialogRef.result
                .then(async (formdata: FormData) => {
                    if (formdata) {
                        try {
                            this.ngxUiLoaderService.start();
                            let result = await this.documentApiService.updateAttachment(formdata).toPromise();

                            if (result.success) {
                                this.customToastService.successToast('Attachments updated Successfully!', 'Success');
                                this.Documentrefresh.next(this.linkEntityType);
                            } else {
                                this.user_utility.errorModelPopup(result.message);
                            }
                            this.ngxUiLoaderService.stop();
                        } catch (err) {
                            this.ngxUiLoaderService.stop();
                            this.user_utility.errorModelPopup(err.message);
                        }
                    }
                })
                .catch((e) => {
                    console.warn(e);
                });
        } else {
            this.user_utility.errorModelPopup(result.message);
        }

        this.ngxUiLoaderService.stop();

        (err) => {
            this.ngxUiLoaderService.stop();
            this.user_utility.errorModelPopup(err.message);
        };
    }

    downloadAttachment(attachment: Attachments) {
        this.ngxUiLoaderService.start();
        this.documentApiService
            .getAttachmentById(attachment.documentId)
            .pipe(takeUntil(this.isSubscribe))
            .subscribe(
                (resp) => {
                    if (resp.success) {
                        if (resp.response.content) {
                            const byteArray = new Uint8Array(
                                atob(resp.response.content)
                                    .split('')
                                    .map((char) => char.charCodeAt(0))
                            );
                            const blob = new Blob([byteArray], {
                                type: 'application/octet-stream',
                            });
                            this.ngxUiLoaderService.stop();
                            const downloadLink = document.createElement('a');
                            downloadLink.href = window.URL.createObjectURL(blob);
                            downloadLink.download = resp.response.filename.replace(/[^a-zA-Z0-9_\-\.]/g, '_');
                            downloadLink.click();
                            window.URL.revokeObjectURL(downloadLink.href);
                        }
                    } else {
                        this.ngxUiLoaderService.stop();
                        this.user_utility.errorModelPopup(resp.message);
                    }
                },
                (err) => {
                    this.user_utility.errorModelPopup(err.message);
                }
            );
    }

    deleteAttachment(attachment: Attachments) {
        let dialogRef = this.modalService.open(DeleteDialogComponent, {
            size: 'sm',
            keyboard: false,
            backdrop: 'static',
        });
        dialogRef.componentInstance.modalMessage = `Are you sure you want to delete ${attachment.name} Document?`;

        dialogRef.result
            .then(async (result) => {
                if (result) {
                    this.ngxUiLoaderService.start();
                    let formdata = new FormData();
                    formdata.append('attachment[DocumentId]', attachment.documentId);
                    formdata.append('attachment[Active]', 'false');

                    let res = await this.documentApiService.updateAttachment(formdata).toPromise();
                    try {
                        if (res.success) {
                            this.customToastService.successToast('Attachment delete Successfully!', 'Success');
                            this.Documentrefresh.next(this.linkEntityType);
                        } else {
                            this.user_utility.errorModelPopup(res.message);
                        }
                        this.ngxUiLoaderService.stop();
                    } catch (err) {
                        this.ngxUiLoaderService.stop();
                    }
                }
            })
            .catch((e) => {
                console.warn(e);
            });
    }

    getProjectType(project: any): string {
        if (!project || !project.projectType) {
            return ''; // Return an empty string or a default value if projectType is null/undefined
        }

        return typeof project.projectType === 'string' ? project.projectType : project.projectType.name || '';
    }
    projectBreadCrumbClick(projectId: string, workpackId?: string) {
        if (workpackId) {
            let data = {
                activityPackDetails: this.activityPackDetails,
                project: this.projectManagerService?.selectedProjectData,
            };
            this.projectManagerService.redirectToProjectBreadCrumb.next(data);
        } else {
            let data = {
                project: this.projectManagerService?.selectedProjectData,
            };
            this.projectManagerService.redirectToProjectBreadCrumb.next(data);
        }
    }

    backToRoute() {
        this.projectManagerService.backToProjectPage.next(true);
    }

    ngOnDestroy(): void {
        this.isSubscribe.unsubscribe();
    }
}
